import FacilityTypeList from "./FacilityTypeList";

export default FacilityTypeList